var _defs, _path, _line, _line2, _path2, _path3, _polyline, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.87,78.88H40a9.78,9.78,0,0,0-9.75,9.75V196.46A9.78,9.78,0,0,0,40,206.22H216a9.75,9.75,0,0,0,9.76-9.76V88.63A9.78,9.78,0,0,0,216,78.88H141"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.32,
    y1: 130.16,
    x2: 200.18,
    y2: 130.16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 143.32,
    y1: 170.16,
    x2: 200.18,
    y2: 170.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.28,205.36v-21C51.28,171.56,60.09,164,72,164L86.71,180.2,100.32,164c11.94,0,21.79,7.52,21.79,20.34v21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.2,132.7a17.51,17.51,0,1,1-35,0v-6.59a17.51,17.51,0,1,1,35,0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "114.77 94.37 114.77 49.77 141.23 49.77 141.23 94.37"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.63,
    y1: 94.99,
    x2: 153.37,
    y2: 94.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.8550daa5186579114facb64143ee8b1f.svg";
export { ForwardRef as ReactComponent };